import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

export const INVOICE_ITEM_IMPORT_DIALOG = 'INVOICE_ITEM_IMPORT_DIALOG';

export const closeInvoiceItemImportDialog = () => {
  store?.dispatch(rootUiActions.removeDialog(INVOICE_ITEM_IMPORT_DIALOG));
};

const useInvoiceItemImportDialog = () => {
  return (onAfterClose?: () => void) => {
    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: INVOICE_ITEM_IMPORT_DIALOG,
          type: INVOICE_ITEM_IMPORT_DIALOG,
          props: ImmutableMap({
            onClose: () => {
              closeInvoiceItemImportDialog();
              onAfterClose?.();
            },
          }),
        }),
      ),
    );
  };
};

export default useInvoiceItemImportDialog;
